module.exports = __webpack_public_path__ + "img/comparer-yellow-shape.ce10e506.svg";